import React from 'react';
import { trackAddToCart } from '../../utils/metaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  'aria-label'?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}
export function CTAButton({
  children,
  className = '',
  href = '#oferta',
  target,
  rel,
  'aria-label': ariaLabel,
  onClick
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  const baseClasses = `
    bg-gradient-to-r from-amber-600 to-amber-700 
    text-white rounded-full 
    px-8 py-5 md:px-12 md:py-6 
    text-[18px] md:text-[22px] font-bold 
    hover:scale-105 hover:shadow-xl 
    transition-all duration-300 ease-in-out
    shadow-lg 
    focus:ring-4 focus:ring-amber-300 focus:outline-none
    w-full sm:w-auto text-center
    inline-block cursor-pointer
    ${className}
  `;
  if (isExternal) {
    return <a href={href} target={target} rel={rel} aria-label={ariaLabel} onClick={e => {
      trackAddToCart();
      if (onClick) (onClick as any)(e);
    }} className={baseClasses} data-id="element-220">
        {children}
      </a>;
  }
  return <a href={href} aria-label={ariaLabel} onClick={e => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
    if (onClick) onClick(e as any);
  }} className={baseClasses} data-id="element-221">
      {children}
    </a>;
}